import * as graphlib from "@dagrejs/graphlib";

export const getNodeIdToConnectedNodeIds = (nodes, edges) => {
    const graph = new graphlib.Graph({
        directed: false
    });

    nodes.forEach(node => {
        graph.setNode(node.id);
    });

    edges.forEach(edge => {
        const sourceId = edge.sourceNodeId;
        const targetId = edge.targetNodeId;

        graph.setEdge(sourceId, targetId, {});
    });

    const components = graphlib.alg.components(graph);
    const map = new Map();

    components.forEach(array => {
        const set = new Set(array);

        array.forEach(nodeId => {
            map.set(nodeId, set);
        });
    });

    nodes.forEach(node => {
        const nodeId = node.id;

        if (!map.has(nodeId)) {
            map.set(nodeId, new Set([nodeId]));
        }
    });

    return Object.fromEntries(map);
};
